import { getAxiosInstance } from '@utils/request';

export interface SearchItem extends GeoJSON.Feature {
  table_name: string;
}

export interface TableSearchResponse {
  _count: number;
  type: 'FeatureCollection';
  features: SearchItem[];
}

export class APITableSearch {
  readonly url = '/api/table-search/';

  async list(searchValue: string, page: number, pageSize: number = 10) {
    const queryParams = new URLSearchParams({
      _search_value: searchValue,
      _page: String(page),
      _page_size: String(pageSize),
    });
    const queryString = '?' + queryParams.toString();
    const response = await getAxiosInstance().get<TableSearchResponse>(
      this.url + queryString,
    );

    return response;
  }
}
